
import { Container, Nav, Navbar,Col, Row} from "react-bootstrap";
import logo from "../shared/image/Dial_Tutor.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { Link ,Outlet} from "react-router-dom";
import React from "react";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import footerLogo from "../shared/image/Dial_Tutor.png";
import "./Footer.css";
import "./Header.css";
export default function Header()
{
    return(
       <div className="public-shell">
              <Navbar expand="lg" className="sticky bg-white shadow-sm customnav">
        <Container>
          <Navbar.Brand as={Link} to="/">
            <img src={logo} alt="logo" height="50" />
          </Navbar.Brand>

          <Navbar.Toggle />
          <Navbar.Collapse>
            <Nav className="mx-auto">
              <Nav.Link as={Link} to="/">Home</Nav.Link>
              <Nav.Link as={Link} to="/teacher/register">Become a Tutor</Nav.Link>
              <Nav.Link as={Link} to="/student/login">Student Login</Nav.Link>
              <Nav.Link as={Link} to="/teacher/login">Teacher Login</Nav.Link>
            </Nav>

            <h5 className="mb-0">
              <a href="tel:7448337000" className="text-dark text-decoration-none">
                <FontAwesomeIcon icon={faPhone} /> 7448337000
              </a>
            </h5>
          </Navbar.Collapse>
        </Container>
      </Navbar>
     
        
                  <Outlet />
                <Container className="mb-5 page-content">
  {/* other sections */}
</Container>
      
       <footer className="footer-section py-5 bg-dark text-white">
            <Container>
      
              {/* TOP ROW */}
              <Row className="mb-4">
      
                {/* Logo + Social */}
                <Col md={3} className="mb-4 mb-md-0 text-center text-md-start">
                  <img src={footerLogo} alt="DialTutor Logo" height="50" className="mb-3" />
                  <div className="social-icons d-flex gap-3">
                    <a href="#" className="text-white"><FaFacebookF /></a>
                    <a href="#" className="text-white"><FaInstagram /></a>
                    <a href="#" className="text-white"><FaLinkedinIn /></a>
                  </div>
                </Col>
      
                {/* Boards */}
                <Col md={3} className="mb-4 mb-md-0">
                  <h6 className="fw-bold">Boards</h6>
                  <ul className="footer-links list-unstyled">
                    <li>CBSE Home Tuition</li>
                    <li>ICSE Home Tuition</li>
                    <li>IGCSE Home Tuition</li>
                    <li>IB Home Tuition</li>
                    <li>State Board Home Tuition</li>
                  </ul>
                </Col>
      
                {/* Subjects */}
                <Col md={3} className="mb-4 mb-md-0">
                  <h6 className="fw-bold">Subjects</h6>
                  <ul className="footer-links list-unstyled">
                    <li>Maths Tuition</li>
                    <li>Physics Tuition</li>
                    <li>Chemistry Tuition</li>
                    <li>Biology Tuition</li>
                    <li>English Tuition</li>
                  </ul>
                </Col>
      
                {/* Services / Others */}
                <Col md={3}>
                  <h6 className="fw-bold">Special Services</h6>
                  <ul className="footer-links list-unstyled">
                    <li>NEET Tuition</li>
                    <li>Shadow Teacher</li>
                    <li>Special Educator</li>
                    <li>Home Schooling</li>
                    <li>Chartered Accounts Tuition</li>
                  </ul>
                </Col>
      
              </Row>
      
              {/* DESCRIPTION */}
              <Row className="mb-3 pt-3  border-top border-secondary">
                <Col>
                  <p className="small">
                   Dial Tutors is a trusted tutor-matching platform that connects students with qualified, 
                    background-verified tutors for academic subjects, music, arts, and fitness. From KG to Class 12 
                    across CBSE, ICSE, IGCSE, IB, and State Boards, we make it easy for parents to find the right tutor 
                    at their doorstep. With personalized learning plans, flexible schedules, and expert guidance, 
                    Dial Tutors empowers students to achieve their goals and helps tutors share their expertise with the world.
                  </p>
                </Col>
              </Row>
      
              {/* BOTTOM ROW */}
              <Row className="pt-3 border-top border-secondary">
                <Col md={6} className="text-center text-md-start mb-2 mb-md-0">
                  <small>
                  <Link to="/privacy" className="custom-condition"> Privacy Policy</Link>  <Link to="/refund" className="custom-condition">• Refund Policy</Link>
                   <Link to="/terms" className="custom-condition">• Terms and Conditions</Link>
                  </small>
                </Col>
                <Col md={6} className="text-center text-md-end">
                  <small>
                    Copyright © Dial Tutors ·
                    <Link to="/admin/login" className="custom-condition ms-1 text-muted">Admin</Link>
                  </small>
                </Col>
              </Row>
      
            </Container>
          </footer>
         </div>
    )
}